
import { defineComponent } from "vue";
import Utility from "@/assets/common/scripts/utility";
import { EstimationData } from "@/views/order-form/order-form-interfaces";
import { ESTIMATION_DATA_DEFAULT } from "@/views/order-form/select-plan/SelectPlan.vue";

export default defineComponent({
  name: "EstimationResult",
  props: {
    estimationData: {
      type: Object as () => EstimationData,
      default: () => {
        return { ...ESTIMATION_DATA_DEFAULT };
      },
    },
    arrivalDate: {
      type: String,
    },
    departureDate: {
      type: String,
    },
  },
  computed: {
    isDatesFilledIn(): boolean {
      return !!this.arrivalDate || !!this.departureDate;
    },
  },
  methods: {
    calculateTravelingDays: Utility.calculateTravelingDays,
    dateFormat: Utility.dateFormat,
  },
});
